import { StringQ } from "@pdfking/structs"
import { CreateSingleton } from "@pdfking/tfunc"

/** A single URL (wasm32 only) or both variants for runtime dispatch. */
export type WasmBinary = string | { wasm32: string; wasm64: string }

/** Memory64 WebAssembly feature detection (cached). */
const SupportsMemory64 = CreateSingleton((): boolean =>
  // Minimal valid WASM module declaring a 64-bit memory (flag 0x04).
  // WebAssembly.validate returns false synchronously if the engine
  // does not support the memory64 proposal.
  WebAssembly.validate(
    new Uint8Array([0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00, 0x05, 0x03, 0x01, 0x04, 0x00])
  )
)

export const ResolveBinary = (binary: WasmBinary): { url: string; memory64: boolean } => {
  if (StringQ(binary)) return { url: binary, memory64: false }
  const memory64 = SupportsMemory64()
  return memory64 ? { url: binary.wasm64, memory64: true } : { url: binary.wasm32, memory64: false }
}
